import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetReferralFunnelV1Response } from './get-referral-funnel-v1-response';
import { getReferralFunnelV1ResponseSchema } from './get-referral-funnel-v1-response';

export async function getReferralFunnelV1Api(
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetReferralFunnelV1Response>> {
  return getRequest<IGetReferralFunnelV1Response>({
    path: '/sys/referral/v1/funnel',
    schema: getReferralFunnelV1ResponseSchema,
    options,
  });
}
